import { GlobalAxios } from "../axios/axios-config";

const SYNC_ALL_ROUTE =
  process.env.REACT_APP_4UBUS + "/api/v1/4uBusAll/Sync/Now";

export const syncAll = () => {
  return GlobalAxios.post(SYNC_ALL_ROUTE);
};
